import { z } from 'zod';
import { environment } from './util.environment.js';
import { makeEnvironmentRef } from './util.make-environment-ref.js';

function asEnum(key, options) {
  const schema = options.defaultValue ? z.enum(options.values).catch(options.defaultValue).default(options.defaultValue) : z.enum(options.values);
  return makeEnvironmentRef(
    () => schema.parse(environment.read(key, { optional: !!options.defaultValue }))
  );
}

export { asEnum };
//# sourceMappingURL=parser.enum.js.map
